import { service } from '@/common/request/request.js'
// 查询埋点事件列表
export function queryListBuried(data = {}) {
  return service({
    url: '/deposit/queryListBuried',
    method: 'post',
    data
  })
}

// 修改埋点上传状态
export function updateBuried(data = {}) {
  return service({
    url: '/deposit/updateBuried',
    method: 'post',
    data
  })
}
// 获取USDT地址列表
export function getUsdtBankList(data = {}) {
    return service({
      url: '/loged/usdtList',
      method: 'post',
      data
    })
  }
// inviteInfo
export function inviteInfo(data = {}) {
  return service({
    url: '/loged/inviteInfo',
    method: 'post',
    data
  })
}
// 邀请列表点击领取奖金按钮，领取奖金
export function getInviteBonus(data = {}) {
  return service({
    url: '/loged/getInviteBonus',
    method: 'post',
    data
  })
}

export function getVerifyParam(data = {}) {
  return service({
    url: '/guest/getVerifyParam',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/common/api/bindAuthenticate.js